import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyCountdown() {
  return <section className="py-20 px-4 bg-bg-pain border-y border-red-urgency/30" data-id="element-253">
      <div className="max-w-4xl mx-auto" data-id="element-254">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-255">
          <h2 className="text-text-primary font-display font-bold text-2xl md:text-3xl mb-8 tracking-wide" data-id="element-256">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <CountdownTimer data-id="element-257" />
          <p className="text-text-primary font-medium text-lg mt-8 mb-4" data-id="element-258">
            ⚠️ Después sube{' '}
            <span className="text-text-gold font-bold" data-id="element-259">$8.000 ARS</span>. No
            vuelve.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-bg-section-alt border border-border-subtle rounded-xl p-8 max-w-2xl mx-auto" data-id="element-260">
          <p className="text-text-primary font-semibold mb-4 text-center" data-id="element-261">
            <span className="text-red-urgency" data-id="element-262">🔴</span> Quedan pocos cupos al
            precio de lanzamiento
          </p>
          <div className="bg-bg-input rounded-full h-3 overflow-hidden mb-3" data-id="element-263">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            delay: 0.5,
            ease: 'easeOut'
          }} className="bg-gradient-to-r from-red-urgency to-red-countdown h-full rounded-full" data-id="element-264" />
          </div>
          <p className="text-text-primary text-[13px] font-medium text-center" data-id="element-265">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </motion.div>
      </div>
    </section>;
}